import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Followup } from "@app/definitions/types"
import { FollowupsUpdateCommons } from "@app/followups-update-commons"
import { flipYesNo } from "@app/helpers"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import {
	BtnExtComponent,
	FollowupModalComponent,
	PatientModalComponent,
	SortThComponent,
	SpinOrContent,
	YesNo,
} from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { TimeFormatPipe } from "@app/utils/time-format.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { AddInvoiceComponent } from "@app/add-invoice/add-invoice.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GroupAttendsComponent } from "@app/group-attends/group-attends.component"

@Component({
	selector: "app-followups-update-list",
	imports: [
		COMMON_IMPORTS,
		GenAutocompleteComponent,
		SpinOrContent,
		SortThComponent,
		LangValPipe,
		PatientModalComponent,
		FollowupModalComponent,
		DateFormatPipe,
		TimeFormatPipe,
		GenInputComponent,
		YesNo,
		BtnExtComponent,
		AddInvoiceComponent,
		ModalWrapComponent,
		GroupAttendsComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./followups-update-list.component.html",
})
export class FollowupsUpdateListComponent extends FollowupsUpdateCommons {
	modalProps: any = null
	apiFuncName: string = "get_followups_for_update"
	hasReceivedExtended: boolean = false
	isFetchingExtended: boolean = false
	@Input() filterField: string = ""
	@Input() objectRow: any = null

	addInvoice(row: any) {
		if (!row.patient_id) {
			return
		}
		const description = this.store.getAddInvoiceDescriptionDefault(
			row.patient_name,
			row.patient_id
		)
		this.modalProps = {
			name: "add-invoice",
			description,
			row,
		}
	}
	onMeetingtypeChange(followup: Followup) {
		if (followup.meetingtype_id) {
			this.saveFollowup(followup)
		}
	}
	resetValue(followup: Followup, isPatient: boolean) {
		if (isPatient) {
			followup.invoice_id_patient = ""
		} else {
			followup.invoice_id_payor = ""
		}
		this.saveFollowup(followup)
	}
	saveFollowup(followup: Followup) {
		if (followup.charged == "no") {
			followup.price = 0
			//followup.sub_user_tarif = 0;
		}

		if (followup.invoice_id > 0) {
			followup.charged_manualy = "yes"
			//followup.sub_user_tarif = 0;
		}

		if (followup.payor_id == 0) {
			followup.price_payor = 0
		}
		this.store.genSaveFollowup(followup)
		this.modalService.openToast("updated_successfully")
	}
	getBaseSendObj() {
		if (!this.filterField || !this.objectRow) {
			return null
		}
		return {
			filterField: this.filterField,
			filterFieldValue: this.objectRow.id,
		}
	}
	async getExtended() {
		this.isFetchingExtended = true
		const res: any = await this.apiService.post(this.apiFuncName, {
			...this.getBaseSendObj(),
			is_extended: true,
		})
		this.load(res)
		this.filterByPatient()
		this.hasReceivedExtended = true
		this.isFetchingExtended = false
	}
	openGroupAttendModal(row: any) {
		this.modalProps = {
			name: "group-attends",
			group_id: row.patient_id,
			followup_id: row.id,
		}
	}
	changeYesNo(row: any, fieldName: any) {
		row[fieldName] = flipYesNo(row[fieldName])
		this.saveFollowup(row)
	}
}
